import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { routes } from '~/constants';
import { axios } from '~/root';
import { qk } from '~/root/query-keys';

type CreatePasswordPayload = {
  token: string;
  password: string;
  confirmPassword: string;
};

export const useCreatePassword = () => {
  const client = useQueryClient();
  const history = useHistory();
  return useMutation({
    mutationFn: (data: CreatePasswordPayload) =>
      axios.post('/v1/users/create-password', data).then(async (response) => {
        await client.refetchQueries(qk.init);
        history.replace(routes.profile.index);

        return response;
      }),
  });
};
